export default {
      id: "icon-plus-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "icons.svg#icon-plus",
      toString: function () {
        return this.url;
      }
    }